import { useMutation } from '@tanstack/react-query';
import { LoadedUser } from '../../interfaces';
import { archiveWaiver, invalidateWaivers } from '../../services/waivers';
import useUser from '../global/useUser';

interface ArchiveWaiverOptions {
  autoRefetch?: boolean;
  disabled?: boolean;
  onSuccess?: () => void | Promise<void>;
  onError?: () => void | Promise<void>;
}

function useArchiveWaiver({
  disabled,
  onSuccess,
  onError,
  autoRefetch = true,
}: ArchiveWaiverOptions = {}) {
  const { user } = useUser<LoadedUser>();

  const businessId = user?.business?.id;

  return useMutation({
    mutationFn: async (waiverId: string) => {
      if (!waiverId || disabled || !businessId) return null;

      const response = await archiveWaiver(waiverId, businessId);

      if (response && autoRefetch) await invalidateWaivers();

      return response;
    },
    onSuccess,
    onError,
  });
}

export default useArchiveWaiver;
